export enum WIDGET_DISPLAY_SIZE {
  COMPACT = 'compact',
  NORMAL = 'normal',
  LARGE = 'large',
}
